export default {"src":"/_next/static/media/bottomCurved_bg_default.567b8e99.svg","height":657,"width":1920};